import { updateEnterpriseInfo } from '@/api/enterpriseAppInfo';
import {
  fetchTagList,
  fetchTagInfo,
  updateTagInfo,
  addTagInfo,
  deleteTag,
  upDateSorting
} from '@/api/label';

import {
  addAdminUser,
  fetchAdminUserList,
  fetchAdminUserInfo,
  updateAdminUserInfo,
  deleteAdminUser,

  fetchUserList,
  deleteUser,
  addUser
} from '@/api/user';

const admin = {
  state: {},
  mutations: {},
  actions: {
    UpDateEnterpriseInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        updateEnterpriseInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTagList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchTagList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetTagInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchTagInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpDateTagInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        updateTagInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddTagInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addTagInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteTag({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteTag(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpDateSorting({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        upDateSorting(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAdminUserList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchAdminUserList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetUserList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchUserList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetAdminUserInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchAdminUserInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpDateAdminUserInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        updateAdminUserInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddAdminUser({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addAdminUser(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddUser({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addUser(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAdminUser({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteAdminUser(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteUser({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteUser(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default admin;



// WEBPACK FOOTER //
// ./src/store/modules/admin.js